import React from 'react';
import UserAvatarPopover from '../AvatarPopover';
import { PapiUser } from '@wix/da-papi-types';
import { ResourceType } from '../../types/resource';
import {
  BiContextAllowedProps,
  BiData,
  UserNameHoverToOpenBiEvent,
} from '@wix/da-bi/pkg/events';
import { isGroup } from '../helpers';

export interface Props {
  user: PapiUser;
  relatedItemBiData?: BiContextAllowedProps;
  biData?: BiContextAllowedProps;
  className?: string;
}

export const UserLinkPopover: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  className,
  relatedItemBiData,
  biData,
  children,
}) => {
  return (
    <UserAvatarPopover
      username={user.username}
      className={className}
      relatedItemBiData={relatedItemBiData}
      biData={BiData<UserNameHoverToOpenBiEvent>({
        evid: 107,
        itemid: user.userId,
        typeid: isGroup(user) ? ResourceType.GROUP : ResourceType.USER,
        ...biData,
      })}
    >
      {children}
    </UserAvatarPopover>
  );
};
UserLinkPopover.displayName = 'UserLinkPopover';

export default UserLinkPopover;
